import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { TRANSFERS_ROUTE_PATHS } from './config';

export const TRANSFERS_ROUTES: TApplicationRoute[] = [
  {
    id: 'treasury-transfers',
    path: TRANSFERS_ROUTE_PATHS.transfers,
    component: lazy(() => import('./pages/pix-transfer-page')),
    layout: 'default',
    permissions: { scopes: ['treasury-transfers'] },
    menu: {
      title: 'pages.treasury.transfers.title',
    },
  },
];
